const COPY = {
  cta1: {
    analytics: {
      marketingAnalyticsEvent: {
        action: 'request_demo',
        tag: 'button',
        context: 'CTAs',
        location: 'hero',
      },
    },
  },
  cta2: {
    analytics: {
      marketingAnalyticsEvent: {
        action: 'see_plans_pricing',
        tag: 'button',
        context: 'CTAs',
        location: 'hero',
      },
    },
  },
  logos: [
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/hashicorp.svg',
      alt: 'HashiCorp',
      height: 42,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/carlsberg.svg',
      alt: 'Carlsberg Group',
      height: 64,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/mercado-libre.svg',
      alt: 'Mercado Libre',
      height: 40,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/3m.svg',
      alt: '3M',
      height: 48,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/linkedin.svg',
      alt: 'LinkedIn',
      height: 36,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/otto.svg',
      alt: 'Otto Group',
      height: 32,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/datadog.svg',
      alt: 'Datadog',
      height: 36,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/telus.svg',
      alt: 'Telus',
      height: 36,
    },
    {
      src: '/images/modules/site/enterprise/advanced-security/logos/kpmg.svg',
      alt: 'KPMG',
      height: 38,
    },
  ],
  bentos: [
    {
      link: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'explore_secret_protection',
            tag: 'link',
            context: 'CTAs',
            location: 'hero',
          },
        },
      },
    },
    {
      link: {
        analytics: {
          marketingAnalyticsEvent: {
            action: 'explore_code_security',
            tag: 'link',
            context: 'CTAs',
            location: 'hero',
          },
        },
      },
    },
  ],
} as const

export default COPY
